const ccList = [
    {
        label: 'English',
        value: 'en',
    },
    {
        label: 'Français',
        value: 'fr',
    },
    {
        label: 'Español',
        value: 'es',
    },
];
const multiLangDomains = {
    demo: [
        {
            label: 'English',
            value: 'en',
        },
    ],
    portal: ccList,
    max: ccList,
    rs: [
        {
            label: 'Serbian',
            value: 'sr',
        },
        {
            label: 'English',
            value: 'en',
        },
    ],
    id: [
        {
            label: 'Indonesian',
            value: 'id',
        },
        {
            label: 'English',
            value: 'en',
        },
    ],
    bg: [
        {
            label: 'Bulgarian',
            value: 'bg',
        },
        {
            label: 'English',
            value: 'en',
        },
    ],
    th: [
        {
            label: 'ไทย',
            value: 'th',
        },
        {
            label: 'English',
            value: 'en',
        },
    ],
};

export default multiLangDomains;
